import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useHistory, useParams} from 'react-router-dom'
import {RootState} from '../../../../../setup'
import {Box, Typography, Button} from '@mui/material'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import {PHYSICAL_ASSESSMENT_CONSTANT_1, PHYSICAL_ASSESSMENT_CONSTANT_2} from '../../../Notes/Physical_Therapist_Notes/PHYSICAL_THERAPIST_CONSTANT'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import axios from 'axios'
import dayjs from 'dayjs'
import {MoonLoader} from 'react-spinners'
import {toast} from 'react-toastify'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs'
import FrequencyDateRangePicker from '../../../../reusable-components/NoteType/NoteType'
import CurrentLevelOfFunctionForm from '../../../Notes/Physical_Therapist_Notes/Assessment/CurrentLevelOfFunctionForm'

const selectTimeZone = (state: RootState) => state.timeZone.timeZone

const DeletedPhysicalAssessmentForm = () => {
  const history = useHistory()
  const [isFormLoading, setIsFormLoading] = useState(false)
  const [physicalAssessmentUiElements, setPhysicalAssessmentUiElements] = useState([])
  const [patientEvaluationUiElements, setPatientEvaluationUiElements] = useState([])
  const [filteredData, setFilteredData] = useState({
    currentLevelOfFunction: {
      availableActivities: [],
      assistanceLevels: [],
      notAttemptedReasons: [],
      patientHasMobilityVehicle: '',
      wheelchairScooterTypes: [],
      activityAssessments: [],
    },
  })
  const [noteData, setNoteData] = useState({
    noteType: '',
  })
  const [clientId, setClientId] = useState('')
  const params: any = useParams()
  const timeZone = useSelector(selectTimeZone)

  const fetchClients = async () => {
    const response = await axios.get('/clients/getClientNames')
    const {data} = response?.data
    const updatedclients = [...data.map((client) => ({label: client.fullName, value: client._id}))]

    const updatedPhysicalAssessmentFormData = PHYSICAL_ASSESSMENT_CONSTANT_1.map((item) => {
      if (item.name === 'clientId') {
        return {
          ...item,
          options: updatedclients,
          disabled: true,
          value: clientId,
        }
      }
      return {
        ...item,
        disabled: true,
      }
    })

    const updatedPatientEvaluationFormData = PHYSICAL_ASSESSMENT_CONSTANT_2.map((item) => ({
      ...item,
      disabled: true,
    }))

    setPhysicalAssessmentUiElements(updatedPhysicalAssessmentFormData)
    setPatientEvaluationUiElements(updatedPatientEvaluationFormData)
  }

  const fetchData = async () => {
    try {
      const response = await axios.get(`/physicalAssessment/getById/${params.id}?isDeleted=true`)
      const {result: data} = response.data

      const tempData = {
        ...data,
        clientId: data?.clientId,
        assessmentDate: data?.assessmentDate
          ? dayjs.utc(data.assessmentDate).tz(timeZone, true)
          : null,
        diagnosis: data?.diagnosis || '',
        onset: data?.onset || '',
        precautions: data?.precautions || '',
        subjective: data?.priorLevelOfFunction?.subjective || '',
        indoorMobility: data?.priorLevelOfFunction?.indoorMobility || '',
        stairs: data?.priorLevelOfFunction?.stairs || '',
        priorDeviceUse: data?.priorDeviceUse || [],
        gaitDeviations: data?.gaitDeviations || '',
        movementPatterns: data?.movementPatterns || '',
        other: data?.other || '',
        lightTouch: data?.sensation?.lightTouch || '',
        sharpDull: data?.sensation?.sharpDull || '',
        deepTouch: data?.sensation?.deepTouch || '',
        hotCold: data?.sensation?.hotCold || '',
        kinesthesia: data?.sensation?.kinesthesia || '',
        proprioception: data?.sensation?.proprioception || '',
        dtr: data?.reflexes?.dtr || '',
        clonus: data?.reflexes?.clonus || '',
        babinski: data?.reflexes?.babinski || '',
        romStatus: data?.rangeOfMotion?.romStatus || '',
        hipFlexion: data?.rangeOfMotion?.hipFlexion || [],
        hipExtension: data?.rangeOfMotion?.hipExtension || [],
        hipAbduction: data?.rangeOfMotion?.hipAbduction || [],
        hipAdduction: data?.rangeOfMotion?.hipAdduction || [],
        hipInternalRotation: data?.rangeOfMotion?.hipInternalRotation || [],
        hipExternalRotation: data?.rangeOfMotion?.hipExternalRotation || [],
        kneeFlexion: data?.rangeOfMotion?.kneeFlexion || [],
        kneeExtension: data?.rangeOfMotion?.kneeExtension || [],
        anklePlantarFlexion: data?.rangeOfMotion?.anklePlantarFlexion || [],
        ankleDorsiFlexion: data?.rangeOfMotion?.ankleDorsiFlexion || [],
        ankleInversion: data?.rangeOfMotion?.ankleInversion || [],
        ankleEversion: data?.rangeOfMotion?.ankleEversion || [],
        impairment: data?.limitations?.impairment || '',
        activityAdlLimitation: data?.limitations?.activityAdlLimitation || '',
        communityParticipationLimitation: data?.limitations?.communityParticipationLimitation || '',
        sittingStatic: data?.balance?.sitting?.static || '',
        sittingDynamic: data?.balance?.sitting?.dynamic || '',
        standingStatic: data?.balance?.standing?.static || '',
        standingDynamic: data?.balance?.standing?.dynamic || '',
        summary: data?.summary || '',
        patientGoals: data?.patientGoals || '',
        treatmentPlanActivities: data?.treatmentPlanActivities || [],
        nextAppt: data?.nextAppt ? dayjs.utc(data.nextAppt).tz(timeZone, true) : null,
        rehabPotential: data?.rehabPotential || '',
        currentLevelOfFunction: {
          availableActivities:
            data?.currentLevelOfFunction?.activityAssessments?.map((a) => a.activity) || [],
          assistanceLevels:
            data?.currentLevelOfFunction?.activityAssessments?.map((a) => a.levelOfAssistance) ||
            [],
          notAttemptedReasons:
            data?.currentLevelOfFunction?.activityAssessments?.map((a) => a.notAttemptedReason) ||
            [],
          patientHasMobilityVehicle: data?.currentLevelOfFunction?.patientHasMobilityVehicle || '',
          wheelchairScooterTypes: data?.currentLevelOfFunction?.wheelchairScooterTypes || [],
          activityAssessments: data?.currentLevelOfFunction?.activityAssessments || [],
        },
      }
      setNoteData({
        noteType: data.noteType,
      })
      setFilteredData(tempData)
      setClientId(data.clientId)
    } catch (error) {
      console.error('Error fetching deleted physical assessment:', error)
      toast.error('Error fetching deleted physical assessment')
    }
  }

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsFormLoading(true)
        await fetchData()
        await fetchClients()
      } catch (error) {
        console.error('Error fetching deleted physical assessment:', error)
      } finally {
        setIsFormLoading(false)
      }
    }
    loadData()
  }, [])

  const buttons = [
    {label: 'Cancel', variant: 'outlined', type: 'button', onClick: () => history.goBack()},
  ]

  if (isFormLoading) {
    return (
      <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
        <MoonLoader color='#9db2fc' size={60} loading={isFormLoading} />
      </div>
    )
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormWrapper
        title='Deleted Physical Assessment'
        content={
          <>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1.5rem',
                marginLeft: '0.5rem',
                marginRight: '0.5rem',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: '0.1rem',
                  marginLeft: 'auto',
                }}
              >
                <Button
                  variant='outlined'
                  onClick={() => history.goBack()}
                  sx={{marginTop: '10px'}}
                >
                  Back
                </Button>
              </Box>
            </Box>
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 'bold',
                marginBottom: '0.5rem',
                marginLeft: '1rem',
              }}
              color='primary'
            >
              Note Type
            </Typography>
            <FrequencyDateRangePicker
              isEntry={false}
              isTemplate={true}
              isFullForm={false}
              isEdit={true}
              formData={noteData}
              setFormData={setNoteData}
              isDeleted={true}
            />
            <Box sx={{mt: 3}}>
              <DynamicForm
                fields={physicalAssessmentUiElements}
                data={filteredData}
                onSubmit={() => {}}
                buttons={[]}
                disabled={true}
              />
              <CurrentLevelOfFunctionForm
                value={filteredData.currentLevelOfFunction}
                onChange={() => {}}
                disabled={true}
                isEdit={true}
              />
            </Box>
            <DynamicForm
              fields={patientEvaluationUiElements}
              data={filteredData}
              onSubmit={() => {}}
              buttons={buttons}
              disabled={true}
            />
          </>
        }
      />
    </LocalizationProvider>
  )
}

export default DeletedPhysicalAssessmentForm
